
import {TweenMax} from 'gsap';

class Slide {
    constructor(el, settings) {
        this.DOM = {el: el};


        this.settings = {
            detailsEl: null,
            onHideDetails: () => {return false;}
        }
        Object.assign(this.settings, settings);


        this.DOM.titleWrap = this.DOM.el.querySelector('.slide-item-number');
        this.DOM.article = this.DOM.el.querySelector('article');
        this.DOM.content = this.DOM.el.querySelector('article');


        // Some config values.
        this.config = {
            animation: {
                duration: 1,
                ease: Expo.easeInOut
            }
        };
    }

    // Sets the current class.
    setCurrent(isCurrent = true) {
        this.DOM.el.classList[isCurrent ? 'add' : 'remove']('slide--current');
    }
    // Hide the slide.
    hide() {
        return this.toggle('hide');
    }
    // Show the slide.
    show(direction) {
        return this.toggle('show');
    }
    // Show/Hide the slide.
    toggle(action) {
        return new Promise((resolve, reject) => {

            let revealerOpts = {
                delay: action === 'hide' ? 0 : this.config.animation.duration / 2,
                ease: this.config.animation.ease,
            };


            TweenMax.to(this.DOM.el, this.config.animation.duration, {
                delay: revealerOpts.delay,
                ease: this.config.animation.ease,
                autoAlpha: action === 'hide' ? 0.01 : 1,
            });
            TweenMax.to(this.DOM.article, this.config.animation.duration, {
                delay: revealerOpts.delay,
                ease: this.config.animation.ease,
                y: action === 'hide' ? "-100%" : "0%",
                force3D:true,
                transformOrigin: action === 'hide' ? "top" : "bottom",
                onComplete: () => {
                    if(action === "hide") {
                        TweenMax.set(this.DOM.article, {
                            y: "100%"
                        })
                    }
                    resolve();
                }
            });


        });
    }
    // Show the details boxes.
}

// The navigation class. Controls the .boxnav animations (e.g. pagination animation).
class Navigation {
    constructor(el, settings,slide) {
        this.DOM = {el: el};

        this.slide = slide;

        this.settings = {
            next: () => {return false;},
            prev: () => {return false;},
            nextDots: () => {return false;}
        }
        Object.assign(this.settings, settings);

        // Navigation controls (prev and next)
        this.DOM.prevCtrl = document.querySelector('.controls .prev');
        this.DOM.nextCtrl = document.querySelector('.controls .next');
        // The current and total pages elements.
        this.DOM.dots = this.DOM.el.querySelectorAll('.liste-savoir');

        this.initEvents();

    }
    // Updates the current page element value.
    // Animate the element up, update the value and finally animate it in from bottom up.
    setCurrent(isCurrent = true) {
        this.DOM.el.classList[isCurrent ? 'add' : 'remove']('slide--current');
    }
    setCurrent(val, isCurrent = true) {

        this.DOM.dots[val].classList[isCurrent ? 'add' : 'remove']('current');
    }
    // Sets the total pages value.
    // Initialize the events on the next/prev controls.
    initEvents() {
        this.DOM.prevCtrl.addEventListener('click', () => this.settings.prev());
        this.DOM.nextCtrl.addEventListener('click', () => this.settings.next());


        this.DOM.dots.forEach((item,index) => {

            item.addEventListener('click', (e) => {
                e.preventDefault();
                this.slide.navigateDots(index);
            });


        })
    }
}

// The Slideshow class.
export default class Slideshow {
    constructor(el) {

        this.DOM = {el: el};
        // Initialize the navigation instance. When clicking the next or prev ctrl buttons, trigger the navigate function.
        this.navigation = new Navigation(document.querySelector('.slide-savoir .slider-nav'), {
            next: () => this.navigate('right'),
            prev: () => this.navigate('left'),
            nextDots: (index) => this.navigateDots(index)
        },this);

        // The slides.
        this.slides = [];
        // Initialize/Create the slides instances.
        Array.from(this.DOM.el.querySelectorAll('.slider-item')).forEach((slideEl,pos) => this.slides.push(new Slide(slideEl, {
            pos,
            // this slide's details element.
            //detailsEl: this.DOM.details[pos],
            // When clicking the close details ctrl button call the closeDetailsBoxes function.
            onHideDetails: () => {
                if ( this.isAnimating ) return;
                this.isAnimating = true;
                this.closeDetailsBoxes().then(() => this.isAnimating = false);
            }
        })));

        // The total number of slides.
        this.slidesTotal = this.slides.length;

        // At least 2 slides to continue...
        /*if ( this.slidesTotal < 2 ) {
            return false;
        }*/
        // Current slide position.
        this.current = 0;
        // Initialize the slideshow.
        this.init();
    }
    // Set the current slide and initialize some events.
    init() {
        this.slides[this.current].setCurrent();
        this.initEvents();
    }
    navigateDots(index) {
        // If animating return.
        if ( this.isAnimating ) return;
        if(index === this.current) return;
        this.isAnimating = true;

        // The next/prev slide´s position.
        const nextSlidePos = index
        // Close the details boxes (if open) and then hide the current slide and show the next/previous one.
        this.closeDetailsBoxes().then(() => {
            // Update the current page element.

            this.navigation.setCurrent(this.current, false);
            this.navigation.setCurrent(nextSlidePos, true);
            Promise.all([this.slides[this.current].hide(), this.slides[nextSlidePos].show()])
                .then(() => {
                    // Update current.
                    this.slides[this.current].setCurrent(false);
                    this.current = nextSlidePos;
                    this.slides[this.current].setCurrent();
                    this.isAnimating = false;
                });
        });

    }
    initEvents() {
        // Open the details boxes.
        //this.DOM.detailsCtrl.addEventListener('click', () => this.openDetailsBoxes());
    }
    openDetailsBoxes() {
        if ( this.isAnimating ) return;
        this.isAnimating = true;

        // Overlay
        //this.DOM.el.classList.add('slideshow--details');

        //this.DOM.detailsWrap.classList.add('details-wrap--open');
        //this.DOM.details[this.current].classList.add('details--current');
        //this.slides[this.current].showDetails().then(() => this.isAnimating = false);
    }
    closeDetailsBoxes() {
        return new Promise((resolve, reject) => {
            // Overlay.
            resolve()
        });
    }
    // Navigate the slideshow.
    navigate(direction) {
        // If animating return.
        if ( this.isAnimating ) return;
        this.isAnimating = true;

        // The next/prev slide´s position.
        const nextSlidePos = direction === 'right' ?
            this.current < this.slidesTotal-1 ? this.current+1 : 0 :
            this.current > 0 ? this.current-1 : this.slidesTotal-1;

        // Close the details boxes (if open) and then hide the current slide and show the next/previous one.
        this.closeDetailsBoxes().then(() => {
            // Update the current page element.

                this.navigation.setCurrent(this.current, false);
                this.navigation.setCurrent(nextSlidePos, true);
            Promise.all([this.slides[this.current].hide("hide"), this.slides[nextSlidePos].show(direction)])
                .then(() => {
                    // Update current.
                    this.slides[this.current].setCurrent(false);
                    this.current = nextSlidePos;
                    this.slides[this.current].setCurrent();
                    this.isAnimating = false;
                });
        });
    }
}



if (!Array.from) {
    Array.from = (function () {
        var toStr = Object.prototype.toString;
        var isCallable = function (fn) {
            return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
        };
        var toInteger = function (value) {
            var number = Number(value);
            if (isNaN(number)) { return 0; }
            if (number === 0 || !isFinite(number)) { return number; }
            return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
        };
        var maxSafeInteger = Math.pow(2, 53) - 1;
        var toLength = function (value) {
            var len = toInteger(value);
            return Math.min(Math.max(len, 0), maxSafeInteger);
        };

        // The length property of the from method is 1.
        return function from(arrayLike/*, mapFn, thisArg */) {
            // 1. Let C be the this value.
            var C = this;

            // 2. Let items be ToObject(arrayLike).
            var items = Object(arrayLike);

            // 3. ReturnIfAbrupt(items).
            if (arrayLike == null) {
                throw new TypeError("Array.from requires an array-like object - not null or undefined");
            }

            // 4. If mapfn is undefined, then let mapping be false.
            var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
            var T;
            if (typeof mapFn !== 'undefined') {
                // 5. else
                // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
                if (!isCallable(mapFn)) {
                    throw new TypeError('Array.from: when provided, the second argument must be a function');
                }

                // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
                if (arguments.length > 2) {
                    T = arguments[2];
                }
            }

            // 10. Let lenValue be Get(items, "length").
            // 11. Let len be ToLength(lenValue).
            var len = toLength(items.length);

            // 13. If IsConstructor(C) is true, then
            // 13. a. Let A be the result of calling the [[Construct]] internal method of C with an argument list containing the single item len.
            // 14. a. Else, Let A be ArrayCreate(len).
            var A = isCallable(C) ? Object(new C(len)) : new Array(len);

            // 16. Let k be 0.
            var k = 0;
            // 17. Repeat, while k < len… (also steps a - h)
            var kValue;
            while (k < len) {
                kValue = items[k];
                if (mapFn) {
                    A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
                } else {
                    A[k] = kValue;
                }
                k += 1;
            }
            // 18. Let putStatus be Put(A, "length", len, true).
            A.length = len;
            // 20. Return A.
            return A;
        };
    }());
}
